import { FdiShop } from "@/abilities/shop/types/fdi-shop";
import { useGetFdiShopConfigLazyQuery } from "@/shared/services/graphql/generated/consumer-graph-types";

// länderkürzel die sich zwischen infotwin und fdi unterscheiden
// key: infotwin | value: fdi
export const FDI_LANGUAGE_ALIAS: Record<string, string> = {
    ja: "jp",
};

export const loadFdiShopConfig = async (): Promise<FdiShop.Config | null> => {
    const { load } = useGetFdiShopConfigLazyQuery();
    const data = await load();
    if (data && data.getFdiShopConfig) {
        const { baseUrl, id } = data.getFdiShopConfig;
        if (!baseUrl || !id) {
            return null;
        }
        return {
            baseUrl,
            id,
        };
    } else {
        return null;
    }
};
